import React from "react";
import PropTypes from "prop-types";
import { UiErrorFallback, UiReloadButton } from "./ErrorFallback.style";

/**
 * 全站 ErrorBoundary 的畫面，錯誤本身已由 Sentry 上報
 */
export const ErrorFallback = ({ eventId }) => {
	return (
		<UiErrorFallback>
			<h2>頁面發生錯誤</h2>
			<p>
				請重新載入頁面，若持續發生請聯絡系統管理員。
				{eventId && <span>（錯誤代碼：{eventId}）</span>}
			</p>
			<UiReloadButton type="button" onClick={() => window.location.reload()}>
				重新載入
			</UiReloadButton>
		</UiErrorFallback>
	);
};

ErrorFallback.propTypes = {
	eventId: PropTypes.string,
};

export default ErrorFallback;
